module.exports = __webpack_public_path__ + "img/evolve-info-yellow-icon.ca9c8f0d.svg";